<template>
    <div class="divider w-100"></div>
</template>
<script>
export default {
    name: "Divider",
};
</script>

<style lang="scss" scoped>
.divider {
    height: 1px;
    background-color: #eee;
}
</style>
